import { createSelector } from "reselect";
import { getInboundDispersalMethod } from "inbounds/steps/InboundStepSelectors";
import { getPlanItemsWithMissingDims } from "inbounds/store/selectors/plan/getPlanItemsWithMissingDims";
import { isEmpty } from "lodash/fp";
import { isShipToOneDispersalMethod } from "inbounds/steps/ship/InboundUtils";

export const selectShouldRequireDimsCollection = createSelector(
  getInboundDispersalMethod,
  getPlanItemsWithMissingDims,
  (dispersalMethod, planItemsWithMissingDims) => {
    const isPlanHasMissingDims = !isEmpty(planItemsWithMissingDims);
    const isShipToOne = isShipToOneDispersalMethod(dispersalMethod);
    return !isShipToOne && isPlanHasMissingDims;
  }
);
